module.exports = __webpack_public_path__ + "img/coupon_bg.610ea63f.png";